import { initializeApp } from "firebase/app";
import { getMessaging, getToken, isSupported, Messaging, } from "firebase/messaging";
import { firebaseConfig, vapidKey } from "./Config";

const app = initializeApp(firebaseConfig);
export let messaging: Messaging | null = null;

export function getFCMMessaging(): Promise<Messaging | null> {
    return isSupported().then(supported => {
        if (supported && typeof window !== "undefined") {
            messaging = getMessaging(app);
            return messaging;
        }
        console.warn("Firebase Messaging not supported here");
        return null;
    });
}



// Request permission & return FCM token
export const requestNotificationPermission = async () => {
    try {
        const status = await Notification.requestPermission();
        if (status !== "granted") return null;

        // const registration = await navigator.serviceWorker.register("/firebase-messaging-sw.js");

        // Get the already-registered service worker
        const registration = await navigator.serviceWorker.ready;
        const msg = await getFCMMessaging();

        if (msg && registration) {
            const currentToken = await getToken(msg, { vapidKey, serviceWorkerRegistration: registration });
            return currentToken;
        }
        return null;
    } catch (err) {
        console.error("FCM token error", err);
        return null;
    }
};
